import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Card, Form, Grid, Menu, Table } from 'semantic-ui-react';
import PageContainer from '../../common/PageContainer';
import * as actions from '../../../redux/actions';
import * as selectors from '../../../redux/selectors';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import * as moment from 'moment';
import * as api from './../../../api/campaignApi';
import { SERVER_URL } from '../../../constants';
import { Formik } from 'formik';
import DigestStatusLabel from '../DigestStatusLabel';

export const NewsAlertSearch = ({ history, cities }) => {
  const [newsAlerts, setNewsAlerts] = useState([]);

  const init = () => api.getNewsAlerts().then(setNewsAlerts);

  useEffect(init, []);

  const addNewsAlert = async () => {
    const { id } = await api.addNewsAlert({
      style: 'News Alert',
      // subject: 'News Alert',
      sendDate: moment().add(1, 'day'),
    });
    history.push(`/news-alert/edit/${id}`);
  };

  const searchNewsAlerts = async query => {
    try {
      console.log('searchNewsAlerts', query);
      const alerts = await api.searchNewsAlerts(query);
      setNewsAlerts(alerts);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <PageContainer>
        <Menu borderless attached="top">
          <Menu.Item header>News Alerts</Menu.Item>

          <Menu.Menu position="right">
            <Menu.Item>
              <Button icon="plus" content="News Alert" labelPosition="left" onClick={addNewsAlert} />
            </Menu.Item>
          </Menu.Menu>
        </Menu>

        <br />

        <Grid>
          <Grid.Column tablet={10} computer={13}>
            <Table size="small" compact="very" celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Subject line</Table.HeaderCell>
                  <Table.HeaderCell width={2}>Style</Table.HeaderCell>
                  <Table.HeaderCell width={2}>City</Table.HeaderCell>
                  <Table.HeaderCell width={3}>Send on</Table.HeaderCell>
                  <Table.HeaderCell>Status</Table.HeaderCell>
                  <Table.HeaderCell collapsing></Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {newsAlerts &&
                  newsAlerts.map((alert, idx) => (
                    <Table.Row key={idx}>
                      <Table.Cell>
                        <Link to={'/news-alert/edit/' + alert.id}>{alert.subject}</Link>
                      </Table.Cell>
                      <Table.Cell>{alert.style}</Table.Cell>
                      <Table.Cell>{alert?.site?.city}</Table.Cell>
                      <Table.Cell>
                        {moment(alert.sendDate).isValid() && moment(alert.sendDate).format('LL, hh:mm a')}
                      </Table.Cell>
                      <Table.Cell>
                        <DigestStatusLabel digest={alert} />
                      </Table.Cell>
                      <Table.Cell>
                        <Button
                          icon="binoculars"
                          as="a"
                          size="mini"
                          target="_blank"
                          href={`${SERVER_URL}/api/news-alert/email/${alert.id}`}
                        />
                      </Table.Cell>
                    </Table.Row>
                  ))}
              </Table.Body>
            </Table>
          </Grid.Column>
          <Grid.Column table={6} computer={3}>
            <Formik initialValues={{ subject: '', siteId: '' }} onSubmit={searchNewsAlerts}>
              {formik => (
                <Form onSubmit={formik.handleSubmit}>
                  <div style={{ display: 'grid', alignItems: 'start' }}>
                    <Card fluid>
                      <Card.Content>
                        <Form.Field>
                          <label>Subject</label>
                          <Form.Input
                            icon="search"
                            name="subject"
                            value={formik.values.subject}
                            onChange={(e, { value }) => formik.setFieldValue('subject', value)}
                          />
                        </Form.Field>

                        <br />

                        <Form.Field>
                          <label>City</label>
                          <Form.Dropdown
                            name="siteId"
                            className="time-dropdown"
                            clearable
                            value={formik.values.siteId}
                            onChange={(e, { value }) => formik.setFieldValue('siteId', value)}
                            fluid
                            selection
                            options={cities}
                          />
                        </Form.Field>

                        <br />

                        <Button loading={formik.isSubmitting} type="submit" content="Submit" positive fluid />
                        <br />

                        <Button
                          content="Clear"
                          type="button"
                          disabled={formik.isSubmitting}
                          onClick={async () => {
                            formik.resetForm();
                            await init();
                          }}
                          fluid
                        />
                      </Card.Content>
                    </Card>
                  </div>
                </Form>
              )}
            </Formik>
          </Grid.Column>
        </Grid>
      </PageContainer>
    </>
  );
};

const mapStateToProps = state => ({
  digests: selectors.getDigests(state),
  promoAlerts: selectors.getPromoAlerts(state),
  cities: selectors.admin.cultureMapCities(state),
  promoAlertFormats: selectors.campaigns.promoAlertFormats(state),
});

const mapDispatchToProps = dispatch => ({
  getPromoAlerts: bindActionCreators(actions.campaign.getPromoAlerts, dispatch),
  clearRecentPosts: bindActionCreators(actions.campaign.clearRecentPosts, dispatch),
  deletePromoAlertById: bindActionCreators(actions.campaign.deletePromoAlertById, dispatch),
  searchPromoAlerts: bindActionCreators(actions.campaign.searchPromoAlerts, dispatch),
  addPromoAlert: bindActionCreators(actions.campaign.addPromoAlert, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewsAlertSearch);
